/*
 * Summer-sale collection tab navigation + email deep-link.
 *
 * Extracted verbatim from the inline <script> in
 * sections/custom-tabs-collections-grid.liquid so it can live in one cached file.
 * The section loads it (non-deferred, at the slider's position) only when
 * show_tab_arrows is on, and marks its root with [data-summersale-tab-nav].
 *
 * Behaviour is unchanged from the inline version:
 *  - select -> scroll model: tap or arrow selects + centres a tab; swipe browses only
 *  - email deep-link (#anchor) selects the matching tab
 *  - on mobile the deep-link does NOT page-scroll (stays where it loaded); desktop scrolls
 *
 * The only change vs inline: the section id is no longer interpolated by Liquid, so the
 * slider / container / thumb are found by element/class within each section root.
 */
(function () {
  function initTabNav(root) {
    // Scope by element/class within this section root instead of the old
    // #Slider-<section.id> id selector (which Liquid used to interpolate).
    var sliderEl = root.querySelector('hdt-slider');
    var container = root.querySelector('.hdt-slider__container');
    var tab = root.querySelector('hdt-tab');
    if (!sliderEl || !container || !tab) return;

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    // Only <button> pills map 1:1 to collections (other_link blocks render <a>).
    var pills = Array.prototype.slice.call(tab.querySelectorAll('button'));
    if (!pills.length) return;

    var prevBtn = root.querySelector('.omr-slider-button[name="previous"]');
    var nextBtn = root.querySelector('.omr-slider-button[name="next"]');
    var thumb = root.querySelector('.hdt-custom-thumb');

    // Embla API: used ONLY to place the active tab at centre and to drive the
    // pink pagination thumb - never to detect which tab is selected.
    var api = null;
    function captureApi(event) {
      if (!event.detail || !event.detail.sliderApi || api) return;
      api = event.detail.sliderApi;
      api.on('scroll', updateThumb);
      api.on('reInit', updateThumb);
      updateThumb();
    }
    sliderEl.addEventListener('init:slide', captureApi);
    sliderEl.addEventListener('select:slide', captureApi);

    function updateThumb() {
      if (!api || !thumb) return;

      // Guard against a non-finite progress: a transient reInit can report
      // NaN before geometry settles, which would write left:NaN%.
      var raw_progress = api.scrollProgress();
      if (!isFinite(raw_progress)) return;

      var progress = Math.min(Math.max(raw_progress, 0), 1);
      thumb.style.transform = 'none';
      thumb.style.left = (progress * 70) + '%';
    }

    // Single source of truth: active tab = the pill with aria-current="true"
    // (hdt-tab maintains it). Selection changes only on a tap or an arrow.
    function activeIndex() {
      for (var i = 0; i < pills.length; i++) {
        if (pills[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    // Embla scrollTo() takes a SNAP index; with default trimSnaps the edge
    // slides are grouped, so map the slide to the snap whose group contains it.
    // Used ONLY to place a known tab (middle tabs centre, 1st/last clamp).
    function snapIndexForSlide(slideIndex) {
      try {
        var registry = api.internalEngine().slideRegistry;
        for (var k = 0; k < registry.length; k++) {
          if (registry[k].indexOf(slideIndex) !== -1) return k;
        }
      } catch (e) {}
      return slideIndex;
    }

    function centerTab(index) {
      if (!api) return;
      var slides = Array.prototype.slice.call(
        container.querySelectorAll('.hdt-slider__slide')
      );
      var slide = pills[index] && pills[index].closest('.hdt-slider__slide');
      var slideIndex = slides.indexOf(slide);
      if (slideIndex >= 0) api.scrollTo(snapIndexForSlide(slideIndex));
    }

    // Prev disabled at the first tab, next at the last - from the active index.
    function updateArrows() {
      var i = activeIndex();
      if (prevBtn) prevBtn.toggleAttribute('disabled', i <= 0);
      if (nextBtn) nextBtn.toggleAttribute('disabled', i >= pills.length - 1);
    }

    // Select a pill via its native click (hdt-tab switches the collection).
    // Embla swallows the FIRST click inside the slider after a drag (its
    // post-drag guard calls stopPropagation, so the click never reaches
    // hdt-tab). A browse-swipe leaves that guard armed and the arrow click is
    // outside the slider, so it doesn't clear it - meaning a single synthetic
    // click would be eaten and the tab would NOT switch (it would only centre).
    // Clicking twice fixes it: the 1st satisfies/clears the guard, the 2nd
    // reaches hdt-tab. hdt-tab ignores a click on the already-active tab, so
    // this never double-selects.
    function selectPill(index) {
      if (pills[index].getAttribute('aria-current') === 'true') return;
      pills[index].click();
      pills[index].click();
    }

    // Arrow = step the SELECTION by one relative to the ACTIVE tab, then centre
    // it. Independent of where the user has browse-scrolled to.
    function step(delta) {
      var target = activeIndex() + delta;
      if (target < 0) target = 0;
      if (target > pills.length - 1) target = pills.length - 1;
      selectPill(target);
      centerTab(target);
      updateArrows();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { if (isMobile()) step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { if (isMobile()) step(1); });

    // Tap a tab: hdt-tab switches the collection natively; we then centre that
    // tab and refresh the arrow state. Swiping the strip changes nothing here.
    // isTrusted ignores the synthetic clicks step() fires.
    container.addEventListener('click', function (event) {
      if (!isMobile() || !event.isTrusted) return;
      var pill = event.target.closest('.hdt-slider__slide button');
      if (!pill) return;
      var index = pills.indexOf(pill);
      if (index < 0) return;
      centerTab(index);
      updateArrows();
    });

    // Email deep-link (e.g. .../all-products#body-tapes): select that tab AND
    // sync the slider - scroll the strip to it (centerTab) + refresh the arrow
    // disabled state (updateArrows). Runs once.
    (function () {
      var hash = (window.location.hash || '').replace('#', '');
      if (!hash || !/^[a-zA-Z0-9_-]+$/.test(hash)) return;
      var hidx = -1;
      for (var hp = 0; hp < pills.length; hp++) {
        if (pills[hp].getAttribute('data-tab-anchor') === hash) { hidx = hp; break; }
      }
      if (hidx < 0) return;

      function finish() {
        // Instant jump only (never smooth): a smooth scroll right after the slider
        // initialises keeps layout in motion and triggers a reInit storm that breaks
        // the arrows / pagination / swipe. On mobile we skip the page scroll entirely
        // (the tab still selects + the slider resyncs); desktop scrolls to the section.
        function land() {
          if (isMobile()) return;
          root.scrollIntoView({ behavior: 'auto', block: 'start' });
        }

        requestAnimationFrame(function () {
          land();

          // The strip was built while offscreen / mid-reveal, so recompute the
          // geometry ONCE on the now-stable layout, centre the deep-linked tab,
          // then refresh the arrow + pagination state.
          requestAnimationFrame(function () {
            if (api) {
              api.reInit();
              centerTab(hidx);
            }
            updateArrows();
            updateThumb();
            land();
          });
        });

        // Re-assert after late reflow settles (lazy images). Instant jumps only.
        setTimeout(land, 300);
        setTimeout(land, 700);
      }

      var htries = 0;
      var hsettled = false;
      setTimeout(function run() {
        if (hsettled) return;
        if (pills[hidx].getAttribute('aria-current') === 'true') {
          hsettled = true;
          finish();
          return;
        }
        selectPill(hidx);
        htries += 1;
        if (htries < 6) {
          setTimeout(run, 250);
        } else {
          hsettled = true;
          finish();
        }
      }, 350);
    })();

    updateArrows();
  }

  var roots = document.querySelectorAll('[data-summersale-tab-nav]');
  for (var r = 0; r < roots.length; r++) {
    initTabNav(roots[r]);
  }
})();
